export const FiasDataTids = {
  modal: 'fias-modal',
  sidePageContainer: 'fias-sidePage-container',
  submitButton: 'fias-button-submit',
  cancelButton: 'fias-button-cancel',
  fullText: 'fias-fullText',
  link: 'fias-link',
  validation: 'fias-validation',
  fieldCountry: 'fias-field-country',
  fieldDivision: 'fias-field-division',
  fieldSearch: 'fias-field-search',
  fieldForeignAddress: 'fias-field-foreignAddress',
  divisionSelectorMunicipal: 'fias-division-selector-municipal',
  divisionSelectorAdministrative: 'fias-division-selector-administrative',
  combobox: 'fias-combobox',
  manualEditButton: 'fias-manual-edit-button',
  inputPostalCode: 'fias-input-postalcode',
  textareaAddress: 'fias-textarea-address',
  form: 'fias-form'
} as const;
